import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.ADDED_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/addedCategory.js